import { gql } from '@apollo/client'

export const UpdateRoom = gql`
    mutation UpdateRoom($roomId: ID!, $updates: UpdateRoomInput!) {
        updateRoom(roomId: $roomId, updates: $updates) {
            id
            room {
                id
                invites {
                    email
                    id
                    issuer {
                        id
                        username
                        avatar
                    }
                    user {
                        id
                        username
                        avatar
                    }
                }
                name
                topic
                spinning
                timezone
                public
                djAccess
                owner {
                    id
                    username
                    avatar
                }
                admins {
                    id
                    username
                    avatar
                }
                members {
                    id
                    username
                    avatar
                }
            }
            updated
        }
    }
`

export default UpdateRoom
